module.exports = __webpack_public_path__ + "VIPH10.png?fc231cc199bc001186e87be97acaf009";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPH10.png
// module id = 82
// module chunks = 0